var map = {
	"./about.png": "8615",
	"./banner_readycall.png": "09f2",
	"./desc-top-e.png": "79ae",
	"./desc-top-i.png": "9a0c",
	"./enfj.png": "cfa3",
	"./enfp.png": "9c6f",
	"./entj.png": "d3db",
	"./entp.png": "7917",
	"./esfj.png": "4092",
	"./esfp.png": "a147",
	"./estj.png": "8aeb",
	"./estp.png": "5189",
	"./i_goods.png": "eaaf",
	"./i_love.png": "b304",
	"./i_love_l.png": "5a34",
	"./i_love_s.png": "9ad5",
	"./i_verse.png": "e7f6",
	"./i_video.png": "2220",
	"./icon-1.png": "d8e1",
	"./icon-10.png": "92a9",
	"./icon-11.png": "ac6b",
	"./icon-12.png": "4a0a",
	"./icon-13.png": "90a7",
	"./icon-14.png": "5b5d",
	"./icon-2.png": "859d",
	"./icon-3.png": "3c1f",
	"./icon-4.png": "b9f9",
	"./icon-5.png": "bfb2",
	"./icon-6.png": "45b0",
	"./icon-7.png": "f212",
	"./icon-8.png": "15e4",
	"./icon-9.png": "28d5",
	"./infj.png": "8594",
	"./infp.png": "fa13",
	"./intj.png": "308d",
	"./intp.png": "12e6",
	"./isfj.png": "37c8",
	"./isfp.png": "1576",
	"./istj.png": "a00c",
	"./istp.png": "72c4",
	"./loading-icon.png": "c2af",
	"./loading-obj.png": "3994",
	"./logo.png": "cf05",
	"./logo_1.png": "93d3",
	"./logo_2.png": "3297",
	"./logo_loa.png": "6ae4",
	"./logo_samaria.png": "2781",
	"./main-bg.png": "5a4a",
	"./main-title.png": "b22f",
	"./main_ani_1.png": "90d2",
	"./main_ani_2.png": "f02d",
	"./main_ani_bg.png": "3bbe",
	"./main_title.png": "16c7",
	"./mbti-1.png": "c686",
	"./mbti-title.png": "a3f9",
	"./ob-name-ENFJ.png": "1079",
	"./ob-name-ENFP.png": "9cb4",
	"./ob-name-ENTJ.png": "2250",
	"./ob-name-ENTP.png": "5bea",
	"./ob-name-ESFJ.png": "af1c",
	"./ob-name-ESFP.png": "d3ef",
	"./ob-name-ESTJ.png": "d8df",
	"./ob-name-ESTP.png": "18ba",
	"./ob-name-INFJ.png": "eeff",
	"./ob-name-INFP.png": "4f57",
	"./ob-name-INTJ.png": "6d98",
	"./ob-name-INTP.png": "d16a",
	"./ob-name-ISFJ.png": "dc8d",
	"./ob-name-ISFP.png": "776e",
	"./ob-name-ISTJ.png": "21a6",
	"./ob-name-ISTP.png": "5497",
	"./readycall_logo.png": "7b88",
	"./result-bg.png": "5709",
	"./samaria.png": "591e",
	"./sub_title.png": "a6f2",
	"./test-card.png": "3d9b",
	"./test-card_backup.png": "9fb0",
	"./test_bg.png": "5f46"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";